<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<div class="absolute flex flex-row h-full w-full">
    <div *ngIf="showSideBar" class="w-16 h-full overflow-x-visible absolute group z-999">
        <div
            class="flex flex-col justify-between items-center h-full overflow-x-visible w-16 bg-primary-1000 transform transition-all hover:w-64">
            <!-- Nav Bar -->
            <div class="relative w-full flex flex-col space-y-3 justify-start items-center overflow-x-visible h-0 grow">
                <!-- Warning Banner -->
                <div class="p-3"
                     *ngIf="showAppNeedsUpdateBanner">
                    <button
                        (click)="reload()"
                        class="flex flex-col space-y-2 p-2 items-center justify-center group-hover:justify-start group-hover:items-start w-full min-w-10 h-10 group-hover:h-20 rounded-md bg-orange-600 hover:bg-orange-400">
                        <!-- Route Icon -->
                        <mat-icon class="text-white icon-size-6" svgIcon="heroicons_solid:exclamation-triangle">
                        </mat-icon>
                        <!-- Route Name -->
                        <div
                            class="text-white text-sm hidden group-hover:flex group-hover:flex-col group-hover:items-start">
                            <div>
                                A new version of aceso is available!
                            </div>
                            <div class="italic">
                                Click here to reload
                            </div>
                        </div>
                    </button>
                </div>
                <!-- Categories -->
                <div
                    class="p-3 relative w-full flex flex-col space-y-3 justify-start items-center h-0 grow overflow-y-scroll overflow-x-visible">
                    <div *ngFor="let navBarCategory of navBarRoutesByCategory"
                         class="w-full flex flex-col space-y-3 justify-start items-start">
                        <!-- Header -->
                        <div class="h-4 min-h-4">
                            <span
                                class="text-primary-300 uppercase hidden group-hover:ml-2 group-hover:block group-hover:line-clamp-1">
                                {{ navBarCategory.name }}
                            </span>
                            <mat-icon class="text-primary-300 block group-hover:hidden w-10 min-w-10"
                                      svgIcon="mat_outline:remove">
                            </mat-icon>
                        </div>
                        <!-- Route Buttons -->
                        <button *ngFor="let navBarRoute of navBarCategory.routes" [routerLink]="[navBarRoute.route]"
                                class="relative flex flex-row space-x-2 p-2 items-center justify-center group-hover:justify-start w-full min-w-10 h-10 rounded-md hover:bg-primary-400"
                                routerLinkActive="bg-primary-500">
                            <!-- Route Icon -->
                            <mat-icon [svgIcon]="navBarRoute.icon" class="icon-size-6 text-white">
                            </mat-icon>
                            <!-- Route Name -->
                            <span class="text-white hidden group-hover:inline group-hover:line-clamp-1">
                                {{ navBarRoute.name }}
                            </span>
                            <!-- Route Badge -->
                            <div *ngIf="navBarRoute.badge && navBarRoute.badge !== '0'"
                                 class="absolute w-4 h-4 rounded-md -top-2 -right-2 bg-red-500 text-white font-semibold text-xs leading-3 text-center content-center">
                                {{ navBarRoute.badge }}
                            </div>
                            <div *ngIf="navBarRoute.badge && navBarRoute.badge !== '0'"
                                 class="animate-ping absolute w-4 h-4 rounded-md -top-2 -right-2 bg-red-200">
                                &nbsp;
                            </div>
                        </button>
                    </div>
                </div>
            </div>
            <!-- User Info -->
            <div class="w-full flex flex-row justify-start p-3">
                <!-- Icon -->
                <div
                    class="relative flex flex-col justify-center items-center w-10 h-10 rounded-md bg-primary-500 group-hover:rounded-r-none">
                <span
                    class="text-white text-xl text-center font-semibold capitalize select-none max-w-10 overflow-x-hidden inline group-hover:hidden">
                    {{ user.name | initials }}
                </span>
                    <mat-icon class="text-white hidden group-hover:inline" svgIcon="heroicons_outline:user">
                    </mat-icon>
                    <div [ngClass]="{
                             'bg-green-500':connectionStatus === WebSocketConnectionStatus.open,
                             'bg-orange-500':connectionStatus === WebSocketConnectionStatus.connecting,
                             'bg-red-500':connectionStatus === WebSocketConnectionStatus.closed
                            }"
                         class="bg-green-500 absolute -right-0.5 -bottom-0.5 w-1.5 h-1.5 rounded-lg">
                    </div>
                </div>
                <!-- Name -->
                <div
                    class="w-full pl-2 text-white flex-col items-start justify-center rounded-md bg-primary-500 hidden group-hover:rounded-l-none group-hover:flex">
                    <div class="line-clamp-1 font-medium">
                        {{ user.name }}
                    </div>
                    <div class="text-xs italic font-normal">
                        {{ user.phone }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Wrapper -->
    <div [ngClass]="{
    'left-16':showSideBar,
    'left-0':!showSideBar
    }" class="absolute flex flex-col flex-auto h-full w-auto right-0">
        <div *ngIf="!user.is_available" class="p-1 font-bold text-center h-8 w-full bg-orange-200 text-orange-900">
            You are marked on leave, please contact your mentor to change this.
        </div>
        <!-- Content -->
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>

    </div>
</div>
